module.exports = __webpack_public_path__ + "img/gnb_logo_kr.aef549ef.png";